(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("html-labels", [], factory);
	else if(typeof exports === 'object')
		exports["html-labels"] = factory();
	else
		root["html-labels"] = factory();
})(self, function() {
return 